import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";
import ControlTitle from "../ControlTitle";

class TextAreaField extends Component {
  shouldComponentUpdate(nextProps) {
    const different =
      this.props.element_value !== nextProps.element_value ||
      this.props.error !== nextProps.error ||
      this.props.validate !== nextProps.validate;
    return different;
  }

  handleChange(e) {
    this.props.onChange(
      this.props.repeatingForm,
      this.props.element_id,
      e.target.value
    );
  }

  renderTextArea() {
    const { element_value, validate, error, element_params } = this.props;
    var maxLength = element_params.H;

    if (validate && error) {
      return (
        <textarea
          className="error"
          rows={5}
          maxLength={maxLength}
          value={element_value}
          onChange={this.handleChange.bind(this)}
        />
      );
    }

    return (
      <textarea
        rows={5}
        maxLength={maxLength}
        value={element_value}
        onChange={this.handleChange.bind(this)}
      />
    );
  }

  render() {
    const { element_prompt, element_value, ...formControl } = this.props;

    return (
      <div className="formControlItem">
        <Form.Field>
          <ControlTitle
            text={element_prompt}
            optional={formControl.element_optional === "1" ? true : false}
          ></ControlTitle>
          {this.renderTextArea()}
        </Form.Field>
      </div>
    );
  }
}

TextAreaField.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired,
  element_id: PropTypes.number.isRequired,
  error: PropTypes.bool.isRequired,
  validate: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default TextAreaField;



// WEBPACK FOOTER //
// ./src/components/TextAreaField/index.js